var _excluded = ["text", "tooltip", "typography", "size", "variant", "customColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import { rgba } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import hexToRGBA from "../../../helpers/hexToRgba";
import useContrastColor from "../../../hooks/useContrastColor";
var IconSvg = function IconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 8a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V8ZM8 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7.625"
  }));
};
IconSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { labelVariantsBackgrounds } from "../../atoms/LabelAtm/LabelAtm.config";
import { getLabelTextColor, labelSizeStyles } from "../../atoms/LabelAtm/LabelAtm.styles";
import TextAtm from "../../atoms/TextAtm";
import TooltipMol from "../TooltipMol";
export var defaultProps = {
  size: "small",
  variant: "default"
};
var emphasis = "medium";
var hoverEmphasis = "high";
var getColorValue = function getColorValue($onColor, $variant, $emphasis, theme) {
  var _labelVariantsBackgro;
  var onColor = (_labelVariantsBackgro = labelVariantsBackgrounds[$variant]) !== null && _labelVariantsBackgro !== void 0 ? _labelVariantsBackgro : $onColor;
  var color = getLabelTextColor(labelVariantsBackgrounds[$variant]);
  var colorValue = color ? getColor(theme, color) : getTextColor(theme, onColor, $emphasis);
  return colorValue;
};
export var Text = styled(TextAtm).withConfig({
  componentId: "sc-rf9690-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $variant = _ref.$variant,
    $customColor = _ref.$customColor,
    $contrastColor = _ref.$contrastColor,
    theme = _ref.theme;
  var mainColor = $customColor ? $contrastColor : getColorValue($onColor, $variant, emphasis, theme);
  return css(["display:inline-block;position:relative;color:", ";&::after{content:\"\";position:absolute;bottom:0;left:0;width:100%;border-bottom:", " dashed ", ";}"], mainColor, unit(1), mainColor);
});
var Icon = styled(IconSvg).withConfig({
  componentId: "sc-rf9690-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    $variant = _ref2.$variant,
    $customColor = _ref2.$customColor,
    $contrastColor = _ref2.$contrastColor,
    theme = _ref2.theme;
  var mainColor = $customColor ? $contrastColor : getColorValue($onColor, $variant, emphasis, theme);
  return css(["margin-left:", ";vertical-align:middle;& path{fill:", ";}& circle{stroke:", ";}"], space(0.5), mainColor, mainColor);
});
export var LabelWithTooltipContainer = styled.div.withConfig({
  componentId: "sc-rf9690-2"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    $size = _ref3.$size,
    $variant = _ref3.$variant,
    $customColor = _ref3.$customColor,
    $contrastColor = _ref3.$contrastColor,
    theme = _ref3.theme;
  var variantBackgroundColor = labelVariantsBackgrounds[$variant];
  var mainHoverColor = $customColor ? $contrastColor : getColorValue($onColor, $variant, hoverEmphasis, theme);
  return css(["display:inline-flex;position:relative;align-items:center;border-radius:", ";&:hover ", "{border-color:", ";color:", ";&::after{border-bottom:", " dashed ", ";}}&:hover ", "{& path{fill:", ";}& circle{stroke:", ";}}", ";", " ", " ", ""], getBorderRadius(theme, "medium"), Text, mainHoverColor, rgba(mainHoverColor, 1), unit(1), rgba(mainHoverColor, 1), Icon, mainHoverColor, mainHoverColor, labelSizeStyles($size), $customColor && css(["background-color:", ";&:hover{background-color:", ";}"], $customColor, hexToRGBA($customColor, 0.8)), !$customColor && variantBackgroundColor && css(["background-color:", ";&:hover{background-color:", ";}"], rgba(getColor(theme, variantBackgroundColor), 1), rgba(getColor(theme, variantBackgroundColor), 0.8)), !$customColor && !variantBackgroundColor && css(["box-shadow:inset 0 0 0 ", " ", ";"], unit(1), getBorderColor(theme, $onColor, emphasis)));
});
export var StyledTooltip = styled(TooltipMol).withConfig({
  componentId: "sc-rf9690-3"
})(["> *:first-child{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;}"]);
function LabelWithTooltipMol(_ref4) {
  var text = _ref4.text,
    tooltip = _ref4.tooltip,
    typography = _ref4.typography,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? defaultProps.size : _ref4$size,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? defaultProps.variant : _ref4$variant,
    customColor = _ref4.customColor,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var contrastColor = useContrastColor(customColor);
  return /*#__PURE__*/React.createElement(LabelWithTooltipContainer, _extends({
    $onColor: onColor,
    $size: size,
    $variant: variant,
    $customColor: customColor,
    $contrastColor: contrastColor
  }, restProps), /*#__PURE__*/React.createElement(Text, {
    typography: typography,
    $variant: variant,
    $customColor: customColor,
    $contrastColor: contrastColor,
    $onColor: onColor
  }, text), /*#__PURE__*/React.createElement(Icon, {
    $onColor: onColor,
    $variant: variant,
    $customColor: customColor,
    $contrastColor: contrastColor
  }), /*#__PURE__*/React.createElement(StyledTooltip, null, tooltip));
}
export default LabelWithTooltipMol;